import { IApi, useClientApi } from '@/setup/api-client'
import { IBaseApiQueryParams } from '@/setup/types/api'
import { useApiQuery } from '@/utils/api/api-query'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import {
    IOrganizationGetLabelsData,
    IOrganizationGetLabelsRequest,
} from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/files/labels/index'

type IGetLabelsQueryPayload = IOrganizationGetLabelsRequest['body']

export type IGetLabelsQueryParams = IGetLabelsQueryPayload & IBaseApiQueryParams

export class GetLabelsQuery {
    static getKey(params: IGetLabelsQueryParams) {
        return ['organization', params.organizationId, 'brands', params.brandSlug, 'files', 'labels']
    }

    static call(api: IApi, params: IGetLabelsQueryParams) {
        const { organizationId, brandSlug, ...payload } = params

        return api
            .post<
                IOrganizationGetLabelsData,
                IGetLabelsQueryPayload
            >(`/organization/${organizationId}/brands/${brandSlug}/files/labels`, payload)
            .then((res) => res?.data)
    }
}

export function useGetLabelsQuery(args: IGetLabelsQueryPayload) {
    const api = useClientApi()
    const { apiParams } = useApiToolbox()

    const payload = {
        ...args,
        ...apiParams,
    } satisfies IGetLabelsQueryParams

    return useApiQuery<IOrganizationGetLabelsData>({
        queryKey: GetLabelsQuery.getKey(payload),
        queryFn: () => GetLabelsQuery.call(api, payload),
        enabled: !!payload.organizationId && !!payload.brandSlug,
    })
}
